'use client';

import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { FiClock, FiCalendar, FiMessageCircle, FiExternalLink, FiGift } from 'react-icons/fi';

import { paths } from 'src/routes/paths';
import { Button } from 'src/components/ui/primitives';

import styles from './workspace-shortcuts.module.css';

const defaultItems = [
  { labelKey: 'timesheet', href: paths.dashboard.timesheet.root, icon: FiClock },
  { labelKey: 'calendar', href: paths.dashboard.calendar, icon: FiCalendar },
  { labelKey: 'chat', href: paths.dashboard.chat, icon: FiMessageCircle },
  { labelKey: 'externallinks', href: paths.dashboard.externalLink.root, icon: FiExternalLink },
  { labelKey: 'loyalty', href: paths.dashboard.loyalty.root, icon: FiGift },
];

/** Reusable shortcuts. Custom items accept { id?, label, href, icon?: ReactComponent }. */
export function WorkspaceShortcuts({ items, className = '', ...props }) {
  const { t } = useTranslation('navbar');
  const shortcuts =
    items ?? defaultItems.map(({ labelKey, ...item }) => ({ ...item, label: t(labelKey) }));

  return (
    <nav aria-label="Workspace shortcuts" className={`${styles.shortcuts} ${className}`} {...props}>
      {shortcuts.map(({ id, label, href, icon: Icon }) => (
        <Button variant="outline" asChild key={id ?? href}>
          <Link href={href}>
            {Icon && (
              <Icon size={16} aria-hidden="true" focusable="false" className={styles.icon} />
            )}
            <span>{label}</span>
          </Link>
        </Button>
      ))}
    </nav>
  );
}
